import {common} from '@priority-software/priority-proto-api/lib';
import {
    getServerStoreData,
    setServerStoreData
} from '../../../services/proto/ServerStorage/service';
import {MailboxSendToggleState, MAILBOXSEND_TOGGLE_KEY} from '../constants';
import {mailboxSendToggleStore} from '../store';
import {CheckedValue} from '../../ToggleButton/enum';

let cachedState: MailboxSendToggleState | null = null;

/**
 * Get MailboxSend toggle state from server storage with caching
 * @returns Promise<MailboxSendToggleState> - The stored toggle state or default to NEW
 */
export const getMailboxToggleState = async (): Promise<MailboxSendToggleState> => {
    if (cachedState !== null) return cachedState;
    const defaultView = MailboxSendToggleState.NEW;

    try {
        const res = await getServerStoreData([MAILBOXSEND_TOGGLE_KEY], false, true);

        let result: MailboxSendToggleState;
        if (res[MAILBOXSEND_TOGGLE_KEY]) {
            const storedValue = res[MAILBOXSEND_TOGGLE_KEY].Str;
            result =
                storedValue === MailboxSendToggleState.CLASSIC
                    ? MailboxSendToggleState.CLASSIC
                    : MailboxSendToggleState.NEW;
        } else {
            // Set default value if no stored value
            result = defaultView;
        }

        cachedState = result;
        mailboxSendToggleStore.toggleUIState(
            result === MailboxSendToggleState.NEW ? CheckedValue.right : CheckedValue.left
        );
        return result;
    } catch (error) {
        console.error('Failed to get mailbox toggle state from server storage:', error);
        // Fallback to default on error and cache it
        const fallbackResult = defaultView;
        cachedState = fallbackResult;

        mailboxSendToggleStore.toggleUIState(CheckedValue.right);
        return fallbackResult;
    }
};

/**
 * Set MailboxSend toggle state in server storage and update cache
 * @param state - The toggle state to store
 * @returns Promise<void>
 */
export const saveMailboxToggleState = async (state: MailboxSendToggleState): Promise<void> => {
    const stateToSave = new common.Constant({Str: state});
    const storeMap = {[MAILBOXSEND_TOGGLE_KEY]: stateToSave};

    setServerStoreData(storeMap, true, false);

    // Update cache after successful server storage
    cachedState = state;
};

/**
 * Check if the current mailbox toggle state is set to NEW
 * @returns boolean - True if state is NEW, false if CLASSIC
 */
export const isNewMailbox = (): boolean => {
    return cachedState === MailboxSendToggleState.NEW;
};
